import '@angular/compiler';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalKioskCreateComponent } from './portal.kiosk.create/portal.kiosk.create.component';
import { PortalKioskFinishComponent } from './portal.kiosk.finish/portal.kiosk.finish.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalKioskCameraComponent } from './portal.kiosk.camera/portal.kiosk.camera.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { ManageComponent } from './manage/manage.component';
import { PortalKioskPrintComponent } from './portal.kiosk.print/portal.kiosk.print.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalKioskMainComponent } from './portal.kiosk.main/portal.kiosk.main.component';
import { PortalKioskFinalComponent } from './portal.kiosk.final/portal.kiosk.final.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        PortalSeasonTreeComponent,
        PageMainComponent,
        PortalSeasonPaginationComponent,
        PortalSeasonFormDropdownComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalKioskCreateComponent,
        PortalKioskFinishComponent,
        LayoutEmptyComponent,
        PortalSeasonModalComponent,
        PortalKioskCameraComponent,
        PortalSeasonAlertComponent,
        ComponentNavComponent,
        ManageComponent,
        PortalKioskPrintComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalKioskMainComponent,
        PortalKioskFinalComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }